import { useRef,useState } from 'react';
import { BsArrowsAngleContract,BsArrowsAngleExpand } from "react-icons/bs";
import {  FaPaperPlane } from 'react-icons/fa';
import { GiInfo } from 'react-icons/gi';
import { IoCloseSharp } from "react-icons/io5";
import { MarkdownViewer } from 'components/MarkdownViewer/MarkdownViewer';
// import { TEST_WEBHOOK_RESPONSES } from './testData'
import ImageAI1 from './ImageAI1.png';

import './ChatWidget.scss';

type UserMessage = {
  sender: 'user';
  text: string;
  username?: string;
  timestamp?: Date;
};

type BotMessage = {
  sender: 'bot';
  text: string | { output: string }[];
  timestamp?: Date;
};

type Message = UserMessage | BotMessage;

interface WindowSize {
  width: number;
  height: number;
  minWidth: number;
  minHeight: number;
}

const WEBHOOK_URL = process.env.REACT_APP_WEBHOOK_URL!;
const API_URL = process.env.REACT_APP_API_URL_LOCAL!;

const MODES = [
  { key: 'thinking', label: 'Поиск' },
  { key: 'bd', label: 'База Данных' },
];

const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState<string>('');
  const [username] = useState('Пользователь');
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [mode, setMode] = useState('bd');
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 450,
    height: 600,
    minWidth: 300,
    minHeight: 400
  });
  const [isExpanded, setIsExpanded] = useState(false);

  const handleOpenChat = async () => {
    setOpen(true);
    if (!sessionId) {
      const newSessionId = await getNewSessionId();
      if (!newSessionId) {
        addBotMessage('Ошибка: не удалось получить sessionId');
      }
    }
  };


  const getNewSessionId = async () => {
    try {
      const res = await fetch(`${API_URL}/api/get-session-id/`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      
      const data = await res.json();
      if (data.SessionId) {
        setSessionId(data.SessionId);
        return data.SessionId;
      } else {
        console.error('sessionId не найден в ответе:', data);
        return null;
      }
    } catch (error) {
      console.error('Ошибка при получении sessionId:', error);
      return null;
    }
  };

  const addBotMessage = (data: any) => {
    let messageContent: any;
    
        if (typeof data === 'string') {
        try {
          const parsed = JSON.parse(data);
          messageContent = Array.isArray(parsed) ? parsed : [{ output: String(parsed) }];
        } catch {
          messageContent = [{ output: data }]; // если не JSON — как простой текст в массиве
        }
      } else if (Array.isArray(data)) {
        messageContent = data; // уже нужный формат
      } else {
        messageContent = [{ output: String(data) }];
      }

    setMessages((msgs) => [...msgs, { 
      sender: 'bot', 
      text: messageContent,
      timestamp: new Date(),
    }]);
  };

  const handleSend = async () => {
    const trimmed = input.trim();
    if (!trimmed || loading) return;
    
    if (!sessionId) {
      addBotMessage('Ошибка: sessionId не получен');
      return;
    }
    
    setMessages((msgs) => [...msgs, { 
      sender: 'user', 
      text: trimmed, 
      username,
      timestamp: new Date(),
    }]);
    setInput('');
    setLoading(true);
    
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 180000); // 3 минуты
      
      const res = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: trimmed, mode, sessionId }),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      const data = await res.json();

      addBotMessage(data.output);
      } catch (e) {
        if (e instanceof Error) {
          if (e.name === 'AbortError') {
            addBotMessage('Превышено время ожидания ответа (3 минуты).');
          } else {
            addBotMessage('Ошибка соединения с сервером.');
          }
        } else {
          addBotMessage('Неизвестная ошибка при соединении с сервером.');
        }
      } finally {
      setLoading(false);
    }
  }

  const clearHistory = async () => {
    setMessages([]);
    const newSessionId = await getNewSessionId();
    if (!newSessionId) {
      addBotMessage('Ошибка: не удалось получить новый sessionId');
    }
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const toggleExpand = () => {
  if (!isExpanded) {
    setWindowSize(prev => ({
      ...prev,
      width: window.innerWidth / 2,
      height: window.innerHeight * 0.8
    }));
  } else {
    setWindowSize(prev => ({
      ...prev,
      width: 450,
      height: 600
    }));
  }
  setIsExpanded(!isExpanded);
  };
  
  return (
    <>
      {!open && (
        <button className="chat-widget__button" onClick={handleOpenChat}>
          <img className="chat-widget__robot-icon" width="66" src={ImageAI1}/>
        </button>
      )}
      {open && (
        <div className="chat-widget__overlay">
          <div 
            className={`chat-widget__window ${isExpanded ? 'chat-widget__window--expanded' : ''}`}
            style={{ 
              width: isExpanded ? '50vw' : `${windowSize.width}px`,
              height: isExpanded ? '80vh' : `${windowSize.height}px`,
              minWidth: `${windowSize.minWidth}px`,
              minHeight: `${windowSize.minHeight}px`
            }}
          >
            <div className="chat-widget__header">
              <div className="chat-widget__title">
                <img className="chat-widget__robot-icon" width="66" src={ImageAI1}/>
                <span className="chat-widget__chat-title">КБА ИИ</span>
              </div>
              <div className="chat-widget__session-id">
                Session: {sessionId ? `${sessionId.substring(0, 8)}...` : 'Загрузка...'}
              </div>
              <div className="chat-widget__header-controls">
                <button 
                  className="chat-widget__header-button"
                  onClick={toggleExpand}
                  title={isExpanded ? 'Свернуть' : 'Развернуть'}
                >
                  {isExpanded ? <BsArrowsAngleContract /> : <BsArrowsAngleExpand />}
                </button>
                <button 
                  className="chat-widget__header-button-close"
                  onClick={() => setOpen(false)}
                >
                  <IoCloseSharp />
                </button>
                
              </div>
              <div className="chat-widget__delete">
              <button 
                className="chat-widget__deleteButton"
                onClick={clearHistory}
                disabled={loading}
                title="Информация о этой кнопке"
              >
                <GiInfo color="red" />
              </button>
            </div>
            </div>
            
            <div className="chat-widget__messages">
              {messages.map((msg, idx) => (
              <div
              key={idx}
              className={`chat-widget__msg chat-widget__msg--${msg.sender}`}
              >
            {msg.sender === 'user' && (
              <div className="chat-widget__msg-username">{msg.username}</div>
            )}
            <div className="chat-widget__msg-text">
              {msg.sender === 'bot' ? (
                // Для бота: передаём в MarkdownViewer
                Array.isArray(msg.text) ? (
                  <MarkdownViewer webhookData={msg.text} className="chat-widget__markdown" />
                ) : (
                  <MarkdownViewer webhookData={msg.text} className="chat-widget__markdown" />
                )
              ) : (
                <span>{msg.text}</span>
              )}
            </div>
            <div className="chat-widget__msg-time">
              {msg.timestamp && formatTime(msg.timestamp)}
            </div>
          </div>
        ))}
            </div>
            <div className="chat-widget__input">
              <div className="chat-widget__modes">
                {MODES.map((m) => (
                  <button
                    key={m.key}
                    className={`chat-widget__mode-btn ${mode === m.key ? 'chat-widget__mode-btn--active' : ''}`}
                    onClick={() => setMode(m.key)}
                    disabled={loading}
                  >
                    {m.label}
                  </button>
                ))}
              </div>
              <div className="chat-widget__send-wrapper">
                <textarea
                  className="chat-widget__send-input"
                  placeholder="Отправить сообщение..."
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleInputKeyDown}
                  disabled={loading}
                />
                <button
                  className="chat-widget__send"
                  onClick={handleSend}
                  disabled={loading || !input.trim()}
                  title="Отправить"
                >
                  {windowSize.width > 450 ? 'Отправить' : <FaPaperPlane />}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;